import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const RecommendedResources = ({ userRole = 'Developer', onResourceClick }) => {
  const recommendedResources = [
    {
      id: 1,
      title: "Smart City IoT Architecture",
      type: "article",
      source: "MIT Technology Review",
      readTime: "8 min read",
      difficulty: "Intermediate",
      tags: ["IoT", "Architecture", "Smart Cities"],
      url: "https://example.com/iot-architecture",
      icon: "FileText"
    },
    {
      id: 2,
      title: "Data Visualization for Urban Planning",
      type: "video",
      source: "Urban Tech Institute",
      duration: "45 min",
      difficulty: "Beginner",
      tags: ["Data Viz", "GIS", "Planning"],
      url: "https://example.com/data-viz-video",
      icon: "Play"
    },
    {
      id: 3,
      title: "AI in Smart Transportation Systems",
      type: "course",
      source: "Smart City Academy",
      duration: "2 hours",
      difficulty: "Advanced",
      tags: ["AI", "Transportation", "Machine Learning"],
      url: "https://example.com/ai-transport-course",
      icon: "BookOpen"
    },
    {
      id: 4,
      title: "Sustainable Energy Management",
      type: "webinar",
      source: "Green Tech Summit",
      duration: "60 min",
      difficulty: "Intermediate",
      tags: ["Energy", "Sustainability", "IoT"],
      url: "https://example.com/energy-webinar",
      icon: "Video"
    },
    {
      id: 5,
      title: "User Experience in Smart City Apps",
      type: "guide",
      source: "UX Design Institute",
      readTime: "12 min read",
      difficulty: "Beginner",
      tags: ["UX", "Mobile", "Design"],
      url: "https://example.com/ux-guide",
      icon: "Smartphone"
    }
  ];

  const getTypeColor = (type) => {
    const colors = {
      article: 'bg-blue-100 text-blue-800',
      video: 'bg-red-100 text-red-800',
      course: 'bg-green-100 text-green-800',
      webinar: 'bg-purple-100 text-purple-800',
      guide: 'bg-orange-100 text-orange-800'
    };
    return colors?.[type] || 'bg-gray-100 text-gray-800';
  };

  const getDifficultyColor = (difficulty) => {
    switch (difficulty) {
      case 'Beginner': return 'text-green-600';
      case 'Intermediate': return 'text-yellow-600';
      case 'Advanced': return 'text-red-600';
      default: return 'text-gray-600';
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-semibold text-foreground">Recommended Resources</h2>
        <Button variant="ghost" size="sm" iconName="ExternalLink" iconPosition="right">
          View All
        </Button>
      </div>
      <div className="space-y-4">
        {recommendedResources?.map((resource) => (
          <div 
            key={resource?.id}
            className="border border-border rounded-lg p-4 hover:border-primary/20 transition-all duration-200 cursor-pointer"
            onClick={() => onResourceClick(resource)}
          >
            <div className="flex items-start space-x-3">
              <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
                <Icon name={resource?.icon} size={18} className="text-primary" />
              </div>
              
              <div className="flex-1 min-w-0">
                <div className="flex items-start justify-between mb-2">
                  <h3 className="font-medium text-foreground text-sm line-clamp-1">
                    {resource?.title}
                  </h3>
                  <Icon name="ExternalLink" size={14} className="text-muted-foreground ml-2 flex-shrink-0" />
                </div>
                
                <div className="flex items-center space-x-2 mb-2">
                  <span className={`px-2 py-1 rounded-full text-xs font-medium ${getTypeColor(resource?.type)}`}>
                    {resource?.type}
                  </span>
                  <span className={`text-xs font-medium ${getDifficultyColor(resource?.difficulty)}`}>
                    {resource?.difficulty}
                  </span>
                </div>
                
                <div className="flex items-center justify-between text-xs text-muted-foreground">
                  <span>{resource?.source}</span>
                  <span>{resource?.readTime || resource?.duration}</span>
                </div>
                
                <div className="flex flex-wrap gap-1 mt-2">
                  {resource?.tags?.slice(0, 3)?.map((tag, index) => (
                    <span key={index} className="px-2 py-1 bg-muted text-muted-foreground text-xs rounded">
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-4 pt-4 border-t border-border">
        <Button variant="outline" fullWidth iconName="Plus" iconPosition="left">
          Suggest a Resource
        </Button>
      </div>
    </div>
  );
};

export default RecommendedResources;